import { Component, HostListener } from '@angular/core';
import { NavItemComponent } from '../nav-item.component';
import { NavItemViewModel } from '../nav-item-view-model';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-profile-nav-item',
  templateUrl: './profile-nav-item.component.html',
  styleUrls: [
    './profile-nav-item.component.scss',
    '../nav-item.component.scss',
    '../drop-down-nav-item/drop-down-nav-item.component.scss'
  ],
  providers: [NavItemViewModel]
})
export class ProfileNavItemComponent extends NavItemComponent {
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isDropdownClicked(event)) {
      this.closeDropdown();
    }
  }

  public isNavItemActive$ = this.viewModel.isNavItemActive$;
  public multiLineNavItem$ = this.viewModel.multiLineNavItem$;
  public hasIcons$ = this.viewModel.hasIcons$;

  public showDropdown$ = new BehaviorSubject<boolean>(false);
  public idSeed = Math.random().toString(36).substring(2);

  private isDropdownClicked(event: MouseEvent): boolean {
    const dropdownElement = document.getElementById('dropdown' + this.idSeed);
    if (!!dropdownElement) {
      return dropdownElement.contains(event.target as Node);
    }
    return false;
  }

  public toggleDropdown(): void {
    this.showDropdown$.once(d => {
      this.showDropdown$.next(!d);
    });
  }

  public closeDropdown(): void {
    this.showDropdown$.next(false);
  }
}
